import { RegistryItem } from "@schemas/agreementconditions/schema";
import { ProductSchema } from "@schemas/agreementconditions/product.schema";
import { RouteSchema } from "@schemas/agreementconditions/route.schema";
import { LocationSchema } from "@schemas/agreementconditions/location.schema";
import { ContainerFullSchema } from "@schemas/agreementconditions/containerFull.schema";
import { ShipSchema } from "@schemas/agreementconditions/ship.schema";
import { WaterLevelSchema } from "@schemas/agreementconditions/waterLevel.schema";
import { ReeferCheckTypeSchema } from "@schemas/agreementconditions/reeferCheckType.schema.ts";

const SchemaRegistry: RegistryItem[] = [
	ProductSchema,
	RouteSchema,
	LocationSchema,
	ContainerFullSchema,
	ShipSchema,
	WaterLevelSchema,
	ReeferCheckTypeSchema,
];

export const AgreementConditionSchema: RegistryItem = Object.assign({} as RegistryItem, ...SchemaRegistry);
